/**
 * Subcategories of the BUILD ticket type.
 *
 * Kept as a flat hardcoded list, matching the existing ad-hoc pattern for OPEN_ORDER
 * subcategories rather than introducing a generalised abstraction.
 *
 * To add one (e.g. DEPLOYMENT_AREA for `UF%` areas): append it here — appending rather than
 * inserting keeps existing wizard tiles in place — add its DMP prefix to
 * AREA_PREFIX_BY_SUBCATEGORY in `dmp.service.ts`, and add its i18n label under
 * `common:buildSubcategory.*`. No migration is needed: the `area_*` columns on tt_tickets are
 * subcategory-agnostic by design.
 */
export const BUILD_SUBCATEGORIES = ['GREENFIELD'];
export function isBuildSubcategory(value) {
    return BUILD_SUBCATEGORIES.includes(value);
}
//# sourceMappingURL=build-subcategories.js.map